export default "__VITE_ASSET__CSEMN5_W__"